(() => {
  const SECTION_SELECTOR = '[data-section-type="signature-gallery-slider"]';
  const TRACK_SELECTOR = '[data-signature-gallery]';
  const sectionInstances = new WeakMap();

  function initSection(section) {
    if (!section) return true;

    if (sectionInstances.has(section)) {
      const instance = sectionInstances.get(section);
      if (instance && typeof instance.resize === 'function') {
        requestAnimationFrame(() => instance.resize());
      }
      return true;
    }

    const track = section.querySelector(TRACK_SELECTOR);
    if (!track) return true;
    if (!window.theme || !window.theme.Flickity) return false;

    const existingInstance = window.theme.Flickity.data(track);
    if (existingInstance) {
      sectionInstances.set(section, existingInstance);
      requestAnimationFrame(() => existingInstance.resize());
      return true;
    }

    const flkty = new window.theme.Flickity(track, {
      cellSelector: '.signature-gallery-slider__cell',
      contain: true,
      wrapAround: false,
      initialIndex: 0,
      pageDots: false,
      prevNextButtons: true,
      draggable: true,
      imagesLoaded: true,
      cellAlign: 'left'
    });

    if (window.theme.flickitySmoothScrolling) {
      window.theme.flickitySmoothScrolling(track);
    }

    sectionInstances.set(section, flkty);
    requestAnimationFrame(() => {
      flkty.select(0, false, true);
      flkty.resize();
    });
    return true;
  }

  function destroySection(section) {
    if (!section || !sectionInstances.has(section)) return;
    const flkty = sectionInstances.get(section);
    if (flkty && typeof flkty.destroy === 'function') {
      flkty.destroy();
    }
    sectionInstances.delete(section);
  }

  function handleBlockSelect(event) {
    const section = event.target.closest(SECTION_SELECTOR);
    if (!section) return;

    initWithRetry(section, 8);
    const flkty = sectionInstances.get(section);
    if (!flkty) return;

    const selectedCell = event.target.closest('.signature-gallery-slider__cell');
    if (selectedCell) {
      flkty.selectCell(selectedCell, false, true);
    }
    requestAnimationFrame(() => flkty.resize());
  }

  function initWithRetry(root = document, retries = 12) {
    const sections = [...root.querySelectorAll(SECTION_SELECTOR)];
    if (!sections.length) return;

    let allReady = true;
    sections.forEach((section) => {
      const ready = initSection(section);
      if (!ready) allReady = false;
    });

    if (!allReady && retries > 0) {
      setTimeout(() => initWithRetry(root, retries - 1), 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithRetry(document));
  } else {
    initWithRetry(document);
  }
  document.addEventListener('shopify:section:load', (event) => initWithRetry(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector(SECTION_SELECTOR);
    destroySection(section);
  });
  document.addEventListener('shopify:section:reorder', (event) => initWithRetry(event.target, 8));
  document.addEventListener('shopify:block:select', handleBlockSelect);
  document.addEventListener('shopify:block:deselect', handleBlockSelect);
})();
